import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { NFeEntradaItemEditarEmMassaRequest } from '../../requests/repo-dfe/nfe-entrada-item-editar-em-massa.request';
import { NFeEntradaSalvarRequest } from '../../requests/repo-dfe/nfe-entrada-salvar.request';
import { NFeEntradaSalvarResponse } from '../../responses/repo-dfe/nfe-entrada-salvar.response';
import { NFeEntradaConfirmarRequest } from '../../requests/orquestrador-compras/nfe-entrada-confirmar.request';
import { NFeEntradaConferenciaResponse } from '../../responses/orquestrador-compras/nfe-entrada-conferencia.response';
import { PedidoCompraVinculadoNFeEntradaListarResponse } from '../../responses/orquestrador-compras/pedido-compra-vinculado-nfe-entrada-listar.response';
import { ImportarXmlNFeEntradaRequest } from '../../requests/repo-dfe/importar-xml-nfe-entrada.request';
import { ImportarXmlNFeEntradaResponse } from '../../responses/repo-dfe/importar-xml-nfe-entrada.response';
import { ReturnStruct } from '../../structs/return.struct';
import { ProdutoAssociacaoResponse } from '../../responses/orquestrador-compras/produto-associacao.response';
import { AtualizarNcmProdutoRequest } from '../../requests/orquestrador-compras/atualizar-ncm-produto.request';
import { AtualizarGtinProdutoRequest } from '../../requests/orquestrador-compras/atualizar-gtin-produto.request';
import { UpsertCodigoFornecedorRequest } from '../../requests/orquestrador-compras/upsert-codigo-fornecedor.request';
import { NFeEntradaEstoqueExcluirRequest } from '../../requests/orquestrador-compras/nfe-entrada-estoque-excluir.request';
import { NFeEntradaReabrirRequest } from '../../requests/orquestrador-compras/nfe-entrada-reabrir.request';
import { CriarNotaFiscalEntradaOcorrenciaRequest } from '../../requests/orquestrador-compras/criar-nota-fiscal-entrada-ocorrencia.request';
import { GetNotaFiscalEntradaHistoricoResponse } from '../../responses/orquestrador-compras/get-nota-fiscal-entrada-historico.response';
import { NFeEntradaFinanceiroExcluirRequest } from '../../requests/orquestrador-compras/nfe-entrada-financeiro-excluir.request';
import { NFeEntradaEstoqueSituacaoRequest } from '../../requests/orquestrador-compras/nfe-entrada-estoque-situacao.request';
import { NFeEntradaEstoqueSituacaoResponse } from '../../responses/orquestrador-compras/nfe-entrada-estoque-situacao.response';
import { NFeEntradaFinanceiroSituacaoRequest } from '../../requests/orquestrador-compras/nfe-entrada-financeiro-situacao.request';
import { NFeEntradaFinanceiroSituacaoResponse } from '../../responses/orquestrador-compras/nfe-entrada-financeiro-situacao.response';
import { NFeEntradaAssociacaoSalvarRequest } from '../../requests/orquestrador-compras/nfe-entrada-associacao-salvar.request';
import { NotaFiscalEntradaListarRequest } from '../../requests/repo-dfe/nota-fiscal-entrada-listar.request';
import { NotaFiscalEntradaListarResponse } from '../../responses/repo-dfe/nota-fiscal-entrada-listar.response';
import { NotaFiscalEntradaGavetaListarRequest } from '../../requests/orquestrador-compras/nota-fiscal-entrada-gaveta-listar.request';
import { NotaFiscalEntradaGavetaListarResponse } from '../../responses/orquestrador-compras/nota-fiscal-entrada-gaveta-listar.response';
import { NotaFiscalEntradaContextoVinculoPedidoResponse } from '../../responses/orquestrador-compras/nota-fiscal-entrada-contexto-vinculo-pedido.response';
import { NotaFiscalEntradaContextosVinculoPedidoRequest } from '../../requests/orquestrador-compras/nota-fiscal-entrada-contextos-vinculo-pedido.request';
import { NotaFiscalEntradaContextosVinculoPedidoResponse } from '../../responses/orquestrador-compras/nota-fiscal-entrada-contextos-vinculo-pedido.response';
import { NotaFiscalEntradaEdicoesVinculoRequest } from '../../requests/orquestrador-compras/nota-fiscal-entrada-edicoes-vinculo.request';
import { NotaFiscalEntradaEdicoesVinculoResponse } from '../../responses/orquestrador-compras/nota-fiscal-entrada-edicoes-vinculo.response';
import { NotaFiscalEntradaVincularItensPedidoRequest } from '../../requests/orquestrador-compras/nota-fiscal-entrada-vincular-itens-pedido.request';
import { NotaFiscalEntradaVincularItensPedidoResponse } from '../../responses/orquestrador-compras/nota-fiscal-entrada-vincular-itens-pedido.response';
import { NotaFiscalEntradaIntegracaoResponse } from '../../responses/orquestrador-compras/nota-fiscal-entrada-integracao.response';
import { CompraNFeEntradaConfrontoItensResponse } from '../../responses/orquestrador-compras/compra-nfe-entrada-confronto-itens.response';
import { NotaFiscalEntradaNotasPorComprasRequest } from '../../requests/orquestrador-compras/nota-fiscal-entrada-notas-por-compras.request';
import { NotaFiscalEntradaNotasPorComprasResponse } from '../../responses/orquestrador-compras/nota-fiscal-entrada-notas-por-compras.response';
import { NFeEntradaCalculoPreviaRequest } from '../../requests/orquestrador-compras/nfe-entrada-calculo-previa.request';
import { NFeEntradaCalculoPreviaResponse } from '../../responses/orquestrador-compras/nfe-entrada-calculo-previa.response';
import { CalculoNFeEntradaResolverResponse } from '@shared/services/responses/orquestrador-compras/calculo-nfe-entrada-resolver.response';
import { NFeEntradaTributosXmlResponse } from '../../responses/orquestrador-compras/nfe-entrada-tributos-xml.response';
import { NFeEntradaAssociacaoConfirmarResponse } from '../../responses/orquestrador-compras/nfe-entrada-associacao-confirmar.response';
import { NFeEntradaXmlResponse } from '../../responses/orquestrador-compras/nfe-entrada-xml.response';
import { NFeEntradaObterResponse } from '../../responses/repo-dfe/nfe-entrada-obter.response';
import { NFeEntradaFormacaoPrecosPreviaRequest } from '../../requests/orquestrador-compras/nfe-entrada-formacao-precos-previa.request';
import { NFeEntradaFormacaoPrecosAplicarRequest } from '../../requests/orquestrador-compras/nfe-entrada-formacao-precos-aplicar.request';
import { NFeEntradaFormacaoPrecosAplicarResponse } from '../../responses/orquestrador-compras/nfe-entrada-formacao-precos-aplicar.response';
import { NFeEntradaFormacaoPrecosPreviaResponse } from '../../responses/orquestrador-compras/nfe-entrada-formacao-precos-previa.response';
import { NFeEntradaFormacaoPrecosResolucaoResponse } from '../../responses/orquestrador-compras/nfe-entrada-formacao-precos-resolucao.response';

@Injectable({ providedIn: 'root' })
export class NotaFiscalEntradaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiOrquestradorCompras + 'NotaFiscalEntrada';

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** Lista a Central pela fachada que combina NF-es, pedidos vinculados e restrições operacionais. */
  public listar(
    request: NotaFiscalEntradaListarRequest,
    paginaAtual = 0
  ): Observable<NotaFiscalEntradaListarResponse> {
    const params = new HttpParams().set('paginaAtual', paginaAtual.toString());
    return this.httpClient
      .post<NotaFiscalEntradaListarResponse>(`${this.apiUrl}/listar`, request, {
        params,
        ...this.addHeaderToken(),
      })
      .pipe(catchError(this.handleError));
  }

  /**
   * Gaveta de NFs do Kanban de Compras: notas de entrada ainda sem pedido vinculado. O filtro de
   * vínculo é regra do endpoint, não do request.
   */
  public listarGaveta(
    request: NotaFiscalEntradaGavetaListarRequest,
    paginaAtual = 0
  ): Observable<NotaFiscalEntradaGavetaListarResponse> {
    const params = new HttpParams().set('paginaAtual', paginaAtual.toString());
    return this.httpClient
      .post<NotaFiscalEntradaGavetaListarResponse>(`${this.apiUrl}/gaveta`, request, {
        params,
        ...this.addHeaderToken(),
      })
      .pipe(catchError(this.handleError));
  }

  /** Contexto do modal de vínculo item da NF × item do pedido: nota + itens já enriquecidos. */
  public contextoVinculoPedido(idNFeEntrada: number): Observable<NotaFiscalEntradaContextoVinculoPedidoResponse> {
    return this.httpClient
      .get<NotaFiscalEntradaContextoVinculoPedidoResponse>(
        `${this.apiUrl}/vinculoPedido/contexto/idNFeEntrada/${idNFeEntrada}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** Contextos do modal de vínculo de várias notas numa chamada (painel da NF no card do pedido). */
  public contextosVinculoPedido(idsNFeEntrada: number[]): Observable<NotaFiscalEntradaContextosVinculoPedidoResponse> {
    const request = new NotaFiscalEntradaContextosVinculoPedidoRequest();
    request.idsNFeEntrada = idsNFeEntrada;
    return this.httpClient
      .post<NotaFiscalEntradaContextosVinculoPedidoResponse>(`${this.apiUrl}/contextosVinculoPedido`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Nota de entrada (vínculo ativo, número e série) de cada compra — agrupamento por NF no quadro. */
  public notasPorCompras(idsCompra: number[]): Observable<NotaFiscalEntradaNotasPorComprasResponse> {
    const request = new NotaFiscalEntradaNotasPorComprasRequest();
    request.idsCompra = idsCompra;
    return this.httpClient
      .post<NotaFiscalEntradaNotasPorComprasResponse>(`${this.apiUrl}/notasPorCompras`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public consultarEdicaoVinculo(idNFeEntrada: number): Observable<ReturnStruct> {
    return this.httpClient.get<ReturnStruct>(`${this.apiUrl}/vinculoPedido/edicao/idNFeEntrada/${idNFeEntrada}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Trava de edição do vínculo de várias notas numa chamada. */
  public consultarEdicoesVinculo(idsNFeEntrada: number[]): Observable<NotaFiscalEntradaEdicoesVinculoResponse> {
    const request = new NotaFiscalEntradaEdicoesVinculoRequest();
    request.idsNFeEntrada = idsNFeEntrada;
    return this.httpClient
      .post<NotaFiscalEntradaEdicoesVinculoResponse>(`${this.apiUrl}/consultarEdicoesVinculo`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public confrontarItensPedido(request: NotaFiscalEntradaVincularItensPedidoRequest): Observable<CompraNFeEntradaConfrontoItensResponse> {
    return this.httpClient.post<CompraNFeEntradaConfrontoItensResponse>(`${this.apiUrl}/confrontarItensPedido`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Concluir do modal de vínculo: grava o vínculo item a item e move o(s) card(s) para Pedido Faturado. */
  public vincularItensPedido(
    request: NotaFiscalEntradaVincularItensPedidoRequest
  ): Observable<NotaFiscalEntradaVincularItensPedidoResponse> {
    return this.httpClient
      .post<NotaFiscalEntradaVincularItensPedidoResponse>(
        `${this.apiUrl}/vincularItensPedido`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** Movimentações de estoque lançadas por cada nota (consulta ao Produto pelo orquestrador). */
  public consultarSituacaoEstoque(request: NFeEntradaEstoqueSituacaoRequest): Observable<NFeEntradaEstoqueSituacaoResponse> {
    return this.httpClient
      .post<NFeEntradaEstoqueSituacaoResponse>(`${this.apiUrl}/estoque/situacao`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Contas a pagar lançadas por cada nota (consulta ao Finanças pelo orquestrador). */
  public consultarSituacaoFinanceira(request: NFeEntradaFinanceiroSituacaoRequest): Observable<NFeEntradaFinanceiroSituacaoResponse> {
    return this.httpClient
      .post<NFeEntradaFinanceiroSituacaoResponse>(`${this.apiUrl}/financeiro/situacao`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public lancarEstoque(idNFeEntrada: number): Observable<NotaFiscalEntradaIntegracaoResponse> {
    return this.httpClient
      .post<NotaFiscalEntradaIntegracaoResponse>(
        `${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/estoque/lancar`,
        null,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public excluirEstoque(
    idNFeEntrada: number,
    request: NFeEntradaEstoqueExcluirRequest
  ): Observable<NotaFiscalEntradaIntegracaoResponse> {
    return this.httpClient
      .post<NotaFiscalEntradaIntegracaoResponse>(
        `${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/estoque/excluir`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** Ocorrências da nota (histórico), por data do fato desc. */
  public getHistorico(idNFeEntrada: number): Observable<GetNotaFiscalEntradaHistoricoResponse> {
    return this.httpClient
      .get<GetNotaFiscalEntradaHistoricoResponse>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/historico`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Grava a anotação do usuário no histórico da nota (tipo Anotação, origem Usuário), em qualquer status. */
  public criarOcorrencia(idNFeEntrada: number, request: CriarNotaFiscalEntradaOcorrenciaRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/ocorrencia`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Reabre a nota lançada para edição (volta a Em lançamento, com a justificativa no histórico). */
  public reabrir(
    idNFeEntrada: number,
    request: NFeEntradaReabrirRequest
  ): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        `${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/reabrir`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public lancarFinanceiro(idNFeEntrada: number): Observable<NotaFiscalEntradaIntegracaoResponse> {
    return this.httpClient
      .post<NotaFiscalEntradaIntegracaoResponse>(
        `${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/financeiro/lancar`,
        null,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public excluirFinanceiro(
    idNFeEntrada: number,
    request: NFeEntradaFinanceiroExcluirRequest
  ): Observable<NotaFiscalEntradaIntegracaoResponse> {
    return this.httpClient
      .post<NotaFiscalEntradaIntegracaoResponse>(
        `${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/financeiro/excluir`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public salvar(request: NFeEntradaSalvarRequest): Observable<NFeEntradaSalvarResponse> {
    return this.httpClient
      .post<NFeEntradaSalvarResponse>(`${this.apiUrl}/salvar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Roda a conferência (Story, §13) sem alterar nada - usada pela pílula e pelo modal de conferência. */
  public conferencia(idNFeEntrada: number): Observable<NFeEntradaConferenciaResponse> {
    return this.httpClient
      .get<NFeEntradaConferenciaResponse>(
        `${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/conferencia`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** Pedidos vinculados à nota e a etapa de cada um no processo de compras (indicador "Pedido com divergência"). */
  public listarPedidosVinculados(idNFeEntrada: number): Observable<PedidoCompraVinculadoNFeEntradaListarResponse> {
    return this.httpClient
      .get<PedidoCompraVinculadoNFeEntradaListarResponse>(
        `${this.apiUrl}/pedidosVinculados/idNFeEntrada/${idNFeEntrada}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** Revalida a conferência no servidor e, se limpo, confirma a entrada (Story, §11). */
  public confirmar(request: NFeEntradaConfirmarRequest): Observable<NFeEntradaConferenciaResponse> {
    return this.httpClient
      .post<NFeEntradaConferenciaResponse>(`${this.apiUrl}/confirmar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Prevê o efeito da edição em massa (ainda não aplicada) sobre as divergências (§4.5), sem
   * persistir nada. O request é o da edição em massa - só os campos marcados chegam preenchidos.
   */
  public simularConferencia(
    request: NFeEntradaItemEditarEmMassaRequest
  ): Observable<NFeEntradaConferenciaResponse> {
    return this.httpClient
      .post<NFeEntradaConferenciaResponse>(
        `${this.apiUrl}/conferencia/simular`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** Fase B2 - valida e importa um XML por chamada (etapas 1-2 do assistente). */
  public importarXml(request: ImportarXmlNFeEntradaRequest): Observable<ImportarXmlNFeEntradaResponse> {
    return this.httpClient
      .post<ImportarXmlNFeEntradaResponse>(`${this.apiUrl}/importarXml`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Resolve defaults e configuração do item sem executar fórmulas. */
  public resolverCalculoItem(request: NFeEntradaCalculoPreviaRequest): Observable<CalculoNFeEntradaResolverResponse> {
    return this.httpClient
      .post<CalculoNFeEntradaResolverResponse>(`${this.apiUrl}/calculo/item/resolver`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Recalcula o item-alvo e os totais, mantendo a operação como prévia. */
  public calcularPreviaItem(request: NFeEntradaCalculoPreviaRequest): Observable<NFeEntradaCalculoPreviaResponse> {
    return this.httpClient
      .post<NFeEntradaCalculoPreviaResponse>(`${this.apiUrl}/calculo/item/previa`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Recalcula os itens habilitados e os totais, sem persistir o rascunho. */
  public calcularPrevia(request: NFeEntradaCalculoPreviaRequest): Observable<NFeEntradaCalculoPreviaResponse> {
    return this.httpClient
      .post<NFeEntradaCalculoPreviaResponse>(`${this.apiUrl}/calculo/previa`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Lê do storage, pelo backend, os valores originais do XML para restauração e confronto. */
  public obterTributosXml(idNFeEntrada: number): Observable<NFeEntradaTributosXmlResponse> {
    return this.httpClient
      .get<NFeEntradaTributosXmlResponse>(
        `${this.apiUrl}/calculo/idNFeEntrada/${idNFeEntrada}/tributosXml`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Carrega a nota lançada, os produtos e as fórmulas efetivas de custo e venda, sem calcular. */
  public resolverFormacaoPrecos(idNFeEntrada: number): Observable<NFeEntradaFormacaoPrecosResolucaoResponse> {
    return this.httpClient
      .get<NFeEntradaFormacaoPrecosResolucaoResponse>(
        `${this.apiUrl}/formacaoPrecos/idNFeEntrada/${idNFeEntrada}/resolver`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Calcula custo e preço de venda com as escolhas da tela, sem gravar nada. */
  public calcularPreviaFormacaoPrecos(request: NFeEntradaFormacaoPrecosPreviaRequest): Observable<NFeEntradaFormacaoPrecosPreviaResponse> {
    return this.httpClient
      .post<NFeEntradaFormacaoPrecosPreviaResponse>(`${this.apiUrl}/formacaoPrecos/previa`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Recalcula no servidor e grava custo, preço de venda e markup conforme as opções ligadas. */
  public aplicarFormacaoPrecos(request: NFeEntradaFormacaoPrecosAplicarRequest): Observable<NFeEntradaFormacaoPrecosAplicarResponse> {
    return this.httpClient
      .post<NFeEntradaFormacaoPrecosAplicarResponse>(`${this.apiUrl}/formacaoPrecos/aplicar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvarAssociacoes(request: NFeEntradaAssociacaoSalvarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/associacao/salvar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public confirmarTodasAssociacoes(request: NFeEntradaAssociacaoSalvarRequest): Observable<NFeEntradaAssociacaoConfirmarResponse> {
    return this.httpClient
      .post<NFeEntradaAssociacaoConfirmarResponse>(`${this.apiUrl}/associacao/confirmarTodos`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Regra 1 de correspondência (Story §3.6) - GTIN/EAN exato. */
  public produtoPorGtin(gtin: string): Observable<ProdutoAssociacaoResponse> {
    return this.httpClient
      .get<ProdutoAssociacaoResponse>(
        `${this.apiUrl}/associacao/produtoPorGtin?gtin=${encodeURIComponent(gtin)}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** Regras 2, 3 e 4 (Story §3.6) - código no fornecedor, com ou sem restringir o fornecedor. */
  public produtoPorCodigoFabricante(
    codigo: string,
    idFornecedor: number | null
  ): Observable<ProdutoAssociacaoResponse> {
    const qs = `codigo=${encodeURIComponent(codigo)}` + (idFornecedor ? `&idFornecedor=${idFornecedor}` : '');
    return this.httpClient
      .get<ProdutoAssociacaoResponse>(
        `${this.apiUrl}/associacao/produtoPorCodigoFabricante?${qs}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  /** SKUs filhos de um produto agrupador de variação, para a associação 1:1. */
  public produtoVariacaoFilhos(idProdutoPai: number): Observable<ProdutoAssociacaoResponse> {
    return this.httpClient
      .get<ProdutoAssociacaoResponse>(
        `${this.apiUrl}/associacao/produtoVariacaoFilhos?idProdutoPai=${idProdutoPai}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public atualizarNcmProduto(request: AtualizarNcmProdutoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/associacao/atualizarNcmProduto`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public atualizarGtinProduto(request: AtualizarGtinProdutoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/associacao/atualizarGtinProduto`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Aprendizado da associação: código, unidade e fator de conversão usados pelo fornecedor. */
  public upsertCodigoFornecedor(request: UpsertCodigoFornecedorRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/associacao/upsertCodigoFornecedor`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Vincula à nota de XML/SEFAZ em lançamento o fornecedor do emitente do XML quando ainda falta
   * (associa, acrescenta o perfil Fornecedor ou cadastra). Devolve a nota atualizada.
   */
  public prepararFornecedor(idNFeEntrada: number): Observable<NFeEntradaObterResponse> {
    return this.httpClient
      .post<NFeEntradaObterResponse>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/prepararFornecedor`, {}, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** XML completo da nota (procNFe recebido da SEFAZ ou XML importado). */
  public obterXml(idNFeEntrada: number): Observable<NFeEntradaXmlResponse> {
    return this.httpClient
      .get<NFeEntradaXmlResponse>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}/xml`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

}
